import {action, observable, makeObservable} from "mobx";
import ListItem from "@arcgis/core/widgets/LayerList/ListItem";

export class LayerListStore {
    hasGroups: boolean;
    isLoading: null | boolean;
    processing: boolean;
    regroupedItems = observable.map<string, ListItem>();
    viewModel: __esri.LayerListViewModel;
    operationalItemsArray: ListItem[] = [];
    constructor() {
        makeObservable(this, {
            hasGroups: observable,
            isLoading: observable,
            processing: observable,
            regroupedItems: observable,
            operationalItemsArray: observable,

            setHasGroups: action,
            setIsLoading: action,
            setProcessing: action,
            setOperationalItemsArray: action
        });
        this.setIsLoading(null);
    }
    addRegroupedItem(key: string, regroupedItem: ListItem){
        this.regroupedItems.set(key, regroupedItem);
    }
    setHasGroups(hasGroups: boolean) {
        this.hasGroups = hasGroups;
    }
    setIsLoading(isLoading: boolean | null) {
        this.isLoading = isLoading;
    }
    setProcessing(processing: boolean) {
        this.processing = processing;
    }
    setViewModel(viewModel: __esri.LayerListViewModel) {
        this.viewModel = viewModel;
    }
    setOperationalItemsArray(operationalItemsArray: ListItem[]) {
        this.operationalItemsArray = operationalItemsArray;
    }
}
